import { useState, useEffect } from 'react';

export function usePrefersDarkMode(): boolean {
  // Initialize synchronously so the first render already reflects the real
  // color scheme, matching the media-scoped hero preload in index.html.
  const [prefersDarkMode, setPrefersDarkMode] = useState(
    () => typeof window !== 'undefined'
      && window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setPrefersDarkMode(mediaQuery.matches);

    const handler = (event: MediaQueryListEvent) => {
      setPrefersDarkMode(event.matches);
    };

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return prefersDarkMode;
}
